import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ICourse, ISchool, SchoolsService } from "src/app/services";

@Component({
  selector: "app-chart-editor",
  templateUrl: "./chart-editor.component.html",
  styleUrls: ["./chart-editor.component.scss"],
})
export class ChartEditorComponent implements AfterViewInit {
  @Input()
  public school: ISchool;

  public selectedParents: ICourse[];

  constructor(
    private readonly schoolsService: SchoolsService
  ) {
  }

  ngAfterViewInit(): void {

  }

  public onSubmit(form: NgForm) {
    console.log("Your form data : ", form.value);
  }

}
